import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme, props }) => css`
    background-color: ${theme.colors.neutral.variant[0]};
    border-radius: 16px;
    padding: 40px;
    max-width: 768px;
    width: 100%;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    text-align: left;
    min-height: fit-content;
    overflow-y: auto;

    @media (max-width: 768px) {
      padding: 24px 16px;
      margin: 8px 0px;
      border-radius: 12px;
      margin-bottom: 30px;
    }

    ${props.readonly &&
    css`
      pointer-events: none;
    `}
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  `,
  jobPreviewContainer: css`
    margin-left: -24px;
    margin-right: -10px;
    background: transparent;

    .editor-paragraph {
      margin: 0;
    }

    ul {
      margin-top: 0;
    }
  `,
  iconContainer: ({ theme }) => css`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.neutral.variant[10]};
  `,
  jobDetails: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
  `,
  textContent: css`
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ul {
      padding-left: 24px;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `,
  section: css`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  actionsWrapper: css`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  `,
  buttons: css`
    display: flex;
    gap: 16px;
    align-items: center;

    @media (max-width: 768px) {
      flex-direction: column;
      width: 100%;
    }
  `,
  divider: ({ theme }) => css`
    height: 1px;
    width: 100%;
    background-color: ${theme.colors.neutral.variant[20]};
  `,
  footer: css`
    display: flex;
    gap: 4px;
  `,
  requirements: css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    p {
      margin: 0;
    }
  `,
  button: css`
    width: 194px;
    justify-content: center;

    @media (max-width: 768px) {
      width: 100%;
    }
  `,
} satisfies Styles<{ readonly: boolean }>;

export const useStyles = withStyles(styles);
